import { useRef, useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import axios from "../../api/axiosClient";
import { Box, Modal, Typography } from "@mui/material";
import PageHeader from "../ui/PageHeader";
import CustomTable from "../ui/CustomTable";

import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { handleError } from "../../services/serviceBase";
import { useLoading } from "../LoadingContext";

const BasketDetailsModal = (props) => {
  const intl = useIntl();
  const idCompany = useSelector((state) => state.common.company);
  const { setLoading } = useLoading();

  const [details, setDetails] = useState([]);
  const [columns, setColumns] = useState([]);

  const modalStyle = {
    position: "relative",
    top: "50%",
    left: "50%",
    width: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    p: 4,
    borderRadius: 2,
  };

  useEffect(() => {
    if (props.openModal) {
      getColumns();
      getDetails();
    }
  }, [props.openModal]);

  const handleClose = () => {
    props.handleCloseModal();
  };

  const getDetails = async () => {
    setLoading(true);
    var url = `/s2s/baskets/${props.basketId}/details`;
    axios
      .get(url)
      .then((response) => {
        setLoading(false);
        setDetails(response.data);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getColumns = () => {
    setColumns([
      {
        field: "barcode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>Barcode</Typography>
        ),
        flex: 1,
      },
      {
        field: "quantity",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>Qty</Typography>
        ),
        flex: 1,
      },
      {
        field: "fixture",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>Carton ID</Typography>
        ),
        flex: 1,
      },
    ]);
  };

  return (
    <Modal open={props.openModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <PageHeader title={`Basket id ${props.basketId}`} />
        <CustomTable
          columns={columns}
          rows={details}
          id={"idS2SBasketDetail"}
        />
      </Box>
    </Modal>
  );
};

export default BasketDetailsModal;
